import { connect } from "react-redux";
import { updateProspect, updateRoProspect } from "../../../../../../store/actions/appConfig";
import { getStakeholders } from "../../../../../../store/selectors/stakeholders";
import { SignatoryResidenceAddressComponent } from "./SignatoryResidenceAddress";
const mapStateToProps = state => ({
  stakeholders: getStakeholders(state)
});
const mapDispatchToProps = {
  updateProspect,
  updateRoProspect
};
export const SignatoryResidenceAddress = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignatoryResidenceAddressComponent);
